<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  components: {
    Loader,
  },
  data() {
    return {
      apexchartupdate:350,
      chartData: {
        series: [
          {
            name: "Cevaplanan Anket",
            data: [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          
        ], 
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: false,
            },
          },
          colors: ["#556ee6", "#f1b44c"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "Ocak",
               "Şubat",
               "Mar",
               "Nisan",
               "Mayıs",
               "Haziran",
               "Temmuz",
               "Ağustos",
               "Eylül",
               "Ekim",
               "Kasım",
               "Aralık",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
      selection: "all",
      BugunCevaplanan:0,
      BuHaftaCevaplanan:0, 
      BuYilCevaplanan:0
    };
  },
  methods: {
     Get(){}
  },
 
  mounted(){ 
      var Data = {
      Filter: "select count(*) from anktanketcevap where to_char(created, 'DD-MM-YYYY') = to_char(CURRENT_DATE, 'DD-MM-YYYY')",
      };
      this.ActionsPost({ Service: "AnktAnketCevap/Raporlama", Data: Data }).then((res) => {
        if (res) {
          this.BugunCevaplanan = res;
        }
      });
       Data = {
      Filter: "select count(*) from anktanketcevap  where date_trunc('week', now()) <= created AND created < date_trunc('week', now()) + '1 week'::interval",
      };
      this.ActionsPost({ Service: "AnktAnketCevap/Raporlama", Data: Data }).then((res) => {
        if (res) {
          this.BuHaftaCevaplanan = res;
        }
      });
      Data = {
      Filter: "select count(*) from anktanketcevap  where date_trunc('year', now()) <= created AND created < date_trunc('year', now()) + '1 year'::interval",
      };
      this.ActionsPost({ Service: "AnktAnketCevap/Raporlama", Data: Data }).then((res) => {
        if (res) {
          this.BuYilCevaplanan = res;
        }
      }); 

      Data = {
      Filter: "(select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-01-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-02-01')::TIMESTAMP)) UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-02-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-03-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-03-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-04-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-04-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-05-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-05-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-06-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-06-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-07-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-07-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-08-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-08-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-09-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-09-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-10-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-10-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-11-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-11-01')::TIMESTAMP) <= created AND created < date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-12-01')::TIMESTAMP))UNION ALL (select count(*) from anktanketcevap where date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-12-01')::TIMESTAMP) <= created AND created <= date_trunc('month', concat((select DATE_PART('year' ,(SELECT CURRENT_TIMESTAMP))) ,'-12-31')::TIMESTAMP))"
      };
     
      this.ActionsPost({ Service: "AnktAnketCevap/RaporlamaExcel", Data: Data }).then((res) => {
        if (res) {   
          this.chartData.series[0].data=[]
          for(var i=0; i<res.length; i++)
            { 
              this.chartData.series[0].data.push (res[i].count)       
            }  
            this.apexchartupdate=this.apexchartupdate+1;
        }
      }); 
  }
};
</script>

<template>
  <Loader  >
  <div class="card-body"> 
    <div class="d-flex flex-wrap">
      <h5 class="card-title me-2">Anketlerin Aylık ve Yıllık Dağılımları</h5>
      
    </div>

    <div class="row text-center">
      <div class="col-lg-4">
        <div class="mt-4">
          <p class="text-muted mb-1">Bugun Alınan Cevap Sayısı</p>
          <h5>{{ BugunCevaplanan }}</h5>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="mt-4">
          <p class="text-muted mb-1">Bu Hafta Alınan Cevap Sayısı</p>
          <h5>
            {{ BuHaftaCevaplanan }}
            
          </h5>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="mt-4">
          <p class="text-muted mb-1">Bu Yıl Alınan Cevap Sayısı</p>
          <h5>
            {{ BuYilCevaplanan }}
          </h5>
        </div>
      </div>
    </div>

    <hr class="mb-4" />

    <apexchart
      class="apex-charts"
      dir="ltr"
      :height="apexchartupdate"
      :series="chartData.series"
      :options="chartData.chartoptions"
      :update="apexchartupdate"
    >
    </apexchart>

  </div>
  </Loader>
</template>
